import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export const IMAGE_UPLOAD = `${BASE_URL}/rest/v1.0/accounts/{performerName}/identities/{identityType}/images`;
export const IDENTITY_URL = `${BASE_URL}/rest/v1.0/accounts/{performerName}/identities`;
export const IDENTITY_URL_GET = `${BASE_URL}/rest/v1.0/accounts/{username}/identities`;

export const UPDATE_STATUS = `${BASE_URL}/rest/v1.0/studio/{username}/pending`;
export const UPDATE_STATUS_STUDIO_PERFORMER = `${BASE_URL}/rest/v1.0/studio/{studioOwnerName}/roster/{performerName}`;
